import { contentStackJSONRichText } from '../../utils/requests/contentstack/contentStackZodSchema';
import type { ContentBlockProps } from './ContentBlock';
export const contentBlockSchema = contentStackJSONRichText.transform<ContentBlockProps>(data => ({
  data
}));